<template>
  <div>
    <q-btn
      :label="fileUrl ? 'File Selected' : 'Upload File'"
      :outline="!fileUrl"
      :disable="disable || computedLoading"
      @click="$refs.file.click()"
    >
      <slot />
    </q-btn>
    <input
      v-show="false"
      ref="file"
      type="file"
      :accept="acceptedFileTypes"
      @change="fileSelected"
    >
    <div
      class="text-negative"
      style="font-size: 10px;"
    >
      {{ error }}
    </div>
    <q-inner-loading :showing="computedLoading" />
  </div>
</template>

<script>

export default {
  name: 'FileUploader',
  props: {
    modelValue: {
      type: String,
      required: false,
      default: null
    },
    urlProperty: {
      type: String,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    disable: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    // Optional model, other than this.model, to use for tracking loading state.
    loadingModel: {
      type: Object,
      required: false,
      default: null
    },
    acceptedFileTypes: {
      type: String,
      required: false,
      default: '.pdf,.jpeg,.png'
    },
    uploadSizeLimitKb: {
      type: Number,
      required: false,
      default: 5000
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      dragover: false,
      error: null
    }
  },
  computed: {
    computedLoading () {
      return this.loading || !!this.loadingModel?.loading || !!this.model?.loading
    },
    fileUrl () {
      return _.get(this.model, this.urlProperty)
    }
  },
  methods: {
    update (value) {
      this.$emit('update:model-value', value)
    },
    fileSelected (event) {
      const file = event.target.files[0]

      if (!file) return

      if (file.size / 1000 > this.uploadSizeLimitKb) {
        this.error = 'File to large, must be less than 5MB'
        return
      } else {
        this.error = null
      }

      this.upload(file)
    },
    drop (event) {
      event.preventDefault()
      const file = event.dataTransfer.files[0]

      if (!file) return

      this.upload(file)
    },
    async upload (file) {
      const model = this.loadingModel || this.model
      model.loading = true

      const { key } = await this.$directUpload.uploadFile(file)

      this.update(key)

      model.loading = false
      this.dragover = false
    },
    dragEnter () {
      this.dragover = true
    },
    dragLeave () {
      this.dragover = false
    }
  }
}

</script>

<style lang="scss" scoped>
.drop-image {
  border: solid 2px black;
}
.dragover {
  border: dotted 4px red !important;
}
</style>
